import { default as _ai_45testADYBjFCiKlMeta } from "/home/runner/work/properplan/properplan/pages/_components/_ai-test.vue?macro=true";
import { default as _buttonsyZjt72tWaGMeta } from "/home/runner/work/properplan/properplan/pages/_components/_buttons.vue?macro=true";
import { default as _calendarxiVG6ggil1Meta } from "/home/runner/work/properplan/properplan/pages/_components/_calendar.vue?macro=true";
import { default as _cardspN2aoT7tsJMeta } from "/home/runner/work/properplan/properplan/pages/_components/_cards.vue?macro=true";
import { default as _checkboxesyYDteIoHVjMeta } from "/home/runner/work/properplan/properplan/pages/_components/_checkboxes.vue?macro=true";
import { default as _copy_45crafter_45inputUkZxUKyOGlMeta } from "/home/runner/work/properplan/properplan/pages/_components/_copy-crafter-input.vue?macro=true";
import { default as _inputsFW7YHbFSWYMeta } from "/home/runner/work/properplan/properplan/pages/_components/_inputs.vue?macro=true";
import { default as _lightbulbK07FkRo4ftMeta } from "/home/runner/work/properplan/properplan/pages/_components/_lightbulb.vue?macro=true";
import { default as _notificationsaykFfDzRT1Meta } from "/home/runner/work/properplan/properplan/pages/_components/_notifications.vue?macro=true";
import { default as _text_45inputmI6KZWGUD3Meta } from "/home/runner/work/properplan/properplan/pages/_components/_text-input.vue?macro=true";
import { default as create_45plan_45from_45templatehFqxNZdEPNMeta } from "/home/runner/work/properplan/properplan/pages/_components/create-plan-from-template.vue?macro=true";
import { default as error_45testaCzgRWNaWsMeta } from "/home/runner/work/properplan/properplan/pages/_components/error-test.vue?macro=true";
import { default as image_45uploadZN6WiosBNHMeta } from "/home/runner/work/properplan/properplan/pages/_components/image-upload.vue?macro=true";
import { default as _91planUid_93ewTAY4eDZqMeta } from "/home/runner/work/properplan/properplan/pages/_components/plan-view/[planUid].vue?macro=true";
import { default as _91phaseUid_93C3EsfBShXsMeta } from "/home/runner/work/properplan/properplan/pages/_components/task-row/[phaseUid].vue?macro=true";
import { default as _91taskId_934XzccOeYJWMeta } from "/home/runner/work/properplan/properplan/pages/_components/today-task-row/[taskId].vue?macro=true";
import { default as users_45task_45listoKilpzWHzDMeta } from "/home/runner/work/properplan/properplan/pages/_components/users-task-list.vue?macro=true";
import { default as calendar9XRcTp0v9XMeta } from "/home/runner/work/properplan/properplan/pages/calendar.vue?macro=true";
import { default as copy_45plan_45templateA69Esbhf0xMeta } from "/home/runner/work/properplan/properplan/pages/copy-plan-template.vue?macro=true";
import { default as indexIxhLKKpo4fMeta } from "/home/runner/work/properplan/properplan/pages/corie-ai/[uid]/index.vue?macro=true";
import { default as indexggUCKydqg1Meta } from "/home/runner/work/properplan/properplan/pages/corie-ai/index.vue?macro=true";
import { default as indexF1LTFzcTFBMeta } from "/home/runner/work/properplan/properplan/pages/dashboard/index.vue?macro=true";
import { default as free_45signupoihuyNWavlMeta } from "/home/runner/work/properplan/properplan/pages/free-signup.vue?macro=true";
import { default as indexVOslCJxzYwMeta } from "/home/runner/work/properplan/properplan/pages/index.vue?macro=true";
import { default as inviteLGqywVbu0DMeta } from "/home/runner/work/properplan/properplan/pages/invite.vue?macro=true";
import { default as link_45testzZiTLczb9bMeta } from "/home/runner/work/properplan/properplan/pages/link-test.vue?macro=true";
import { default as merge_45testvDJ4jZeBOpMeta } from "/home/runner/work/properplan/properplan/pages/merge-test.vue?macro=true";
import { default as _91uid_93xwT9V8GRtXMeta } from "/home/runner/work/properplan/properplan/pages/my-plan-templates/[uid].vue?macro=true";
import { default as indexip7H2D1kbiMeta } from "/home/runner/work/properplan/properplan/pages/my-plan-templates/index.vue?macro=true";
import { default as _91uid_93H2YMfCtSyzMeta } from "/home/runner/work/properplan/properplan/pages/my-plans/[uid].vue?macro=true";
import { default as indexVeswRojeWIMeta } from "/home/runner/work/properplan/properplan/pages/my-plans/index.vue?macro=true";
import { default as _91uid_93N3VzvSwJ7wMeta } from "/home/runner/work/properplan/properplan/pages/plan-sync-test/[uid].vue?macro=true";
import { default as _91uid_93bM3dGgBA6jMeta } from "/home/runner/work/properplan/properplan/pages/plan-template/[uid].vue?macro=true";
import { default as sign_45up_45lifetimeA46WwbIs9iMeta } from "/home/runner/work/properplan/properplan/pages/sign-up-lifetime.vue?macro=true";
import { default as sign_45upQkQ0oRhIPfMeta } from "/home/runner/work/properplan/properplan/pages/sign-up.vue?macro=true";
import { default as _91uid_9397JExMoWECMeta } from "/home/runner/work/properplan/properplan/pages/task-list-test/[uid].vue?macro=true";
import { default as indexhRW2RLPWb1Meta } from "/home/runner/work/properplan/properplan/pages/template-library/index.vue?macro=true";
import { default as indexOQD3jYUc2SMeta } from "/home/runner/work/properplan/properplan/pages/user-settings/index.vue?macro=true";
export default [
  {
    name: _ai_45testADYBjFCiKlMeta?.name ?? "_components-_ai-test",
    path: _ai_45testADYBjFCiKlMeta?.path ?? "/_components/_ai-test",
    meta: _ai_45testADYBjFCiKlMeta || {},
    alias: _ai_45testADYBjFCiKlMeta?.alias || [],
    redirect: _ai_45testADYBjFCiKlMeta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/_components/_ai-test.vue").then(m => m.default || m)
  },
  {
    name: _buttonsyZjt72tWaGMeta?.name ?? "_components-_buttons",
    path: _buttonsyZjt72tWaGMeta?.path ?? "/_components/_buttons",
    meta: _buttonsyZjt72tWaGMeta || {},
    alias: _buttonsyZjt72tWaGMeta?.alias || [],
    redirect: _buttonsyZjt72tWaGMeta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/_components/_buttons.vue").then(m => m.default || m)
  },
  {
    name: _calendarxiVG6ggil1Meta?.name ?? "_components-_calendar",
    path: _calendarxiVG6ggil1Meta?.path ?? "/_components/_calendar",
    meta: _calendarxiVG6ggil1Meta || {},
    alias: _calendarxiVG6ggil1Meta?.alias || [],
    redirect: _calendarxiVG6ggil1Meta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/_components/_calendar.vue").then(m => m.default || m)
  },
  {
    name: _cardspN2aoT7tsJMeta?.name ?? "_components-_cards",
    path: _cardspN2aoT7tsJMeta?.path ?? "/_components/_cards",
    meta: _cardspN2aoT7tsJMeta || {},
    alias: _cardspN2aoT7tsJMeta?.alias || [],
    redirect: _cardspN2aoT7tsJMeta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/_components/_cards.vue").then(m => m.default || m)
  },
  {
    name: _checkboxesyYDteIoHVjMeta?.name ?? "_components-_checkboxes",
    path: _checkboxesyYDteIoHVjMeta?.path ?? "/_components/_checkboxes",
    meta: _checkboxesyYDteIoHVjMeta || {},
    alias: _checkboxesyYDteIoHVjMeta?.alias || [],
    redirect: _checkboxesyYDteIoHVjMeta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/_components/_checkboxes.vue").then(m => m.default || m)
  },
  {
    name: _copy_45crafter_45inputUkZxUKyOGlMeta?.name ?? "_components-_copy-crafter-input",
    path: _copy_45crafter_45inputUkZxUKyOGlMeta?.path ?? "/_components/_copy-crafter-input",
    meta: _copy_45crafter_45inputUkZxUKyOGlMeta || {},
    alias: _copy_45crafter_45inputUkZxUKyOGlMeta?.alias || [],
    redirect: _copy_45crafter_45inputUkZxUKyOGlMeta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/_components/_copy-crafter-input.vue").then(m => m.default || m)
  },
  {
    name: _inputsFW7YHbFSWYMeta?.name ?? "_components-_inputs",
    path: _inputsFW7YHbFSWYMeta?.path ?? "/_components/_inputs",
    meta: _inputsFW7YHbFSWYMeta || {},
    alias: _inputsFW7YHbFSWYMeta?.alias || [],
    redirect: _inputsFW7YHbFSWYMeta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/_components/_inputs.vue").then(m => m.default || m)
  },
  {
    name: _lightbulbK07FkRo4ftMeta?.name ?? "_components-_lightbulb",
    path: _lightbulbK07FkRo4ftMeta?.path ?? "/_components/_lightbulb",
    meta: _lightbulbK07FkRo4ftMeta || {},
    alias: _lightbulbK07FkRo4ftMeta?.alias || [],
    redirect: _lightbulbK07FkRo4ftMeta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/_components/_lightbulb.vue").then(m => m.default || m)
  },
  {
    name: _notificationsaykFfDzRT1Meta?.name ?? "_components-_notifications",
    path: _notificationsaykFfDzRT1Meta?.path ?? "/_components/_notifications",
    meta: _notificationsaykFfDzRT1Meta || {},
    alias: _notificationsaykFfDzRT1Meta?.alias || [],
    redirect: _notificationsaykFfDzRT1Meta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/_components/_notifications.vue").then(m => m.default || m)
  },
  {
    name: _text_45inputmI6KZWGUD3Meta?.name ?? "_components-_text-input",
    path: _text_45inputmI6KZWGUD3Meta?.path ?? "/_components/_text-input",
    meta: _text_45inputmI6KZWGUD3Meta || {},
    alias: _text_45inputmI6KZWGUD3Meta?.alias || [],
    redirect: _text_45inputmI6KZWGUD3Meta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/_components/_text-input.vue").then(m => m.default || m)
  },
  {
    name: create_45plan_45from_45templatehFqxNZdEPNMeta?.name ?? "_components-create-plan-from-template",
    path: create_45plan_45from_45templatehFqxNZdEPNMeta?.path ?? "/_components/create-plan-from-template",
    meta: create_45plan_45from_45templatehFqxNZdEPNMeta || {},
    alias: create_45plan_45from_45templatehFqxNZdEPNMeta?.alias || [],
    redirect: create_45plan_45from_45templatehFqxNZdEPNMeta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/_components/create-plan-from-template.vue").then(m => m.default || m)
  },
  {
    name: error_45testaCzgRWNaWsMeta?.name ?? "_components-error-test",
    path: error_45testaCzgRWNaWsMeta?.path ?? "/_components/error-test",
    meta: error_45testaCzgRWNaWsMeta || {},
    alias: error_45testaCzgRWNaWsMeta?.alias || [],
    redirect: error_45testaCzgRWNaWsMeta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/_components/error-test.vue").then(m => m.default || m)
  },
  {
    name: image_45uploadZN6WiosBNHMeta?.name ?? "_components-image-upload",
    path: image_45uploadZN6WiosBNHMeta?.path ?? "/_components/image-upload",
    meta: image_45uploadZN6WiosBNHMeta || {},
    alias: image_45uploadZN6WiosBNHMeta?.alias || [],
    redirect: image_45uploadZN6WiosBNHMeta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/_components/image-upload.vue").then(m => m.default || m)
  },
  {
    name: _91planUid_93ewTAY4eDZqMeta?.name ?? "_components-plan-view-planUid",
    path: _91planUid_93ewTAY4eDZqMeta?.path ?? "/_components/plan-view/:planUid()",
    meta: _91planUid_93ewTAY4eDZqMeta || {},
    alias: _91planUid_93ewTAY4eDZqMeta?.alias || [],
    redirect: _91planUid_93ewTAY4eDZqMeta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/_components/plan-view/[planUid].vue").then(m => m.default || m)
  },
  {
    name: _91phaseUid_93C3EsfBShXsMeta?.name ?? "_components-task-row-phaseUid",
    path: _91phaseUid_93C3EsfBShXsMeta?.path ?? "/_components/task-row/:phaseUid()",
    meta: _91phaseUid_93C3EsfBShXsMeta || {},
    alias: _91phaseUid_93C3EsfBShXsMeta?.alias || [],
    redirect: _91phaseUid_93C3EsfBShXsMeta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/_components/task-row/[phaseUid].vue").then(m => m.default || m)
  },
  {
    name: _91taskId_934XzccOeYJWMeta?.name ?? "_components-today-task-row-taskId",
    path: _91taskId_934XzccOeYJWMeta?.path ?? "/_components/today-task-row/:taskId()",
    meta: _91taskId_934XzccOeYJWMeta || {},
    alias: _91taskId_934XzccOeYJWMeta?.alias || [],
    redirect: _91taskId_934XzccOeYJWMeta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/_components/today-task-row/[taskId].vue").then(m => m.default || m)
  },
  {
    name: users_45task_45listoKilpzWHzDMeta?.name ?? "_components-users-task-list",
    path: users_45task_45listoKilpzWHzDMeta?.path ?? "/_components/users-task-list",
    meta: users_45task_45listoKilpzWHzDMeta || {},
    alias: users_45task_45listoKilpzWHzDMeta?.alias || [],
    redirect: users_45task_45listoKilpzWHzDMeta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/_components/users-task-list.vue").then(m => m.default || m)
  },
  {
    name: calendar9XRcTp0v9XMeta?.name ?? "calendar",
    path: calendar9XRcTp0v9XMeta?.path ?? "/calendar",
    meta: calendar9XRcTp0v9XMeta || {},
    alias: calendar9XRcTp0v9XMeta?.alias || [],
    redirect: calendar9XRcTp0v9XMeta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/calendar.vue").then(m => m.default || m)
  },
  {
    name: copy_45plan_45templateA69Esbhf0xMeta?.name ?? "copy-plan-template",
    path: copy_45plan_45templateA69Esbhf0xMeta?.path ?? "/copy-plan-template",
    meta: copy_45plan_45templateA69Esbhf0xMeta || {},
    alias: copy_45plan_45templateA69Esbhf0xMeta?.alias || [],
    redirect: copy_45plan_45templateA69Esbhf0xMeta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/copy-plan-template.vue").then(m => m.default || m)
  },
  {
    name: indexIxhLKKpo4fMeta?.name ?? "corie-ai-uid",
    path: indexIxhLKKpo4fMeta?.path ?? "/corie-ai/:uid()",
    meta: indexIxhLKKpo4fMeta || {},
    alias: indexIxhLKKpo4fMeta?.alias || [],
    redirect: indexIxhLKKpo4fMeta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/corie-ai/[uid]/index.vue").then(m => m.default || m)
  },
  {
    name: indexggUCKydqg1Meta?.name ?? "corie-ai",
    path: indexggUCKydqg1Meta?.path ?? "/corie-ai",
    meta: indexggUCKydqg1Meta || {},
    alias: indexggUCKydqg1Meta?.alias || [],
    redirect: indexggUCKydqg1Meta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/corie-ai/index.vue").then(m => m.default || m)
  },
  {
    name: indexF1LTFzcTFBMeta?.name ?? "dashboard",
    path: indexF1LTFzcTFBMeta?.path ?? "/dashboard",
    meta: indexF1LTFzcTFBMeta || {},
    alias: indexF1LTFzcTFBMeta?.alias || [],
    redirect: indexF1LTFzcTFBMeta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/dashboard/index.vue").then(m => m.default || m)
  },
  {
    name: free_45signupoihuyNWavlMeta?.name ?? "free-signup",
    path: free_45signupoihuyNWavlMeta?.path ?? "/free-signup",
    meta: free_45signupoihuyNWavlMeta || {},
    alias: free_45signupoihuyNWavlMeta?.alias || [],
    redirect: free_45signupoihuyNWavlMeta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/free-signup.vue").then(m => m.default || m)
  },
  {
    name: indexVOslCJxzYwMeta?.name ?? "index",
    path: indexVOslCJxzYwMeta?.path ?? "/",
    meta: indexVOslCJxzYwMeta || {},
    alias: indexVOslCJxzYwMeta?.alias || [],
    redirect: indexVOslCJxzYwMeta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/index.vue").then(m => m.default || m)
  },
  {
    name: inviteLGqywVbu0DMeta?.name ?? "invite",
    path: inviteLGqywVbu0DMeta?.path ?? "/invite",
    meta: inviteLGqywVbu0DMeta || {},
    alias: inviteLGqywVbu0DMeta?.alias || [],
    redirect: inviteLGqywVbu0DMeta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/invite.vue").then(m => m.default || m)
  },
  {
    name: link_45testzZiTLczb9bMeta?.name ?? "link-test",
    path: link_45testzZiTLczb9bMeta?.path ?? "/link-test",
    meta: link_45testzZiTLczb9bMeta || {},
    alias: link_45testzZiTLczb9bMeta?.alias || [],
    redirect: link_45testzZiTLczb9bMeta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/link-test.vue").then(m => m.default || m)
  },
  {
    name: merge_45testvDJ4jZeBOpMeta?.name ?? "merge-test",
    path: merge_45testvDJ4jZeBOpMeta?.path ?? "/merge-test",
    meta: merge_45testvDJ4jZeBOpMeta || {},
    alias: merge_45testvDJ4jZeBOpMeta?.alias || [],
    redirect: merge_45testvDJ4jZeBOpMeta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/merge-test.vue").then(m => m.default || m)
  },
  {
    name: _91uid_93xwT9V8GRtXMeta?.name ?? "my-plan-templates-uid",
    path: _91uid_93xwT9V8GRtXMeta?.path ?? "/my-plan-templates/:uid()",
    meta: _91uid_93xwT9V8GRtXMeta || {},
    alias: _91uid_93xwT9V8GRtXMeta?.alias || [],
    redirect: _91uid_93xwT9V8GRtXMeta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/my-plan-templates/[uid].vue").then(m => m.default || m)
  },
  {
    name: indexip7H2D1kbiMeta?.name ?? "my-plan-templates",
    path: indexip7H2D1kbiMeta?.path ?? "/my-plan-templates",
    meta: indexip7H2D1kbiMeta || {},
    alias: indexip7H2D1kbiMeta?.alias || [],
    redirect: indexip7H2D1kbiMeta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/my-plan-templates/index.vue").then(m => m.default || m)
  },
  {
    name: _91uid_93H2YMfCtSyzMeta?.name ?? "my-plans-uid",
    path: _91uid_93H2YMfCtSyzMeta?.path ?? "/my-plans/:uid()",
    meta: _91uid_93H2YMfCtSyzMeta || {},
    alias: _91uid_93H2YMfCtSyzMeta?.alias || [],
    redirect: _91uid_93H2YMfCtSyzMeta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/my-plans/[uid].vue").then(m => m.default || m)
  },
  {
    name: indexVeswRojeWIMeta?.name ?? "my-plans",
    path: indexVeswRojeWIMeta?.path ?? "/my-plans",
    meta: indexVeswRojeWIMeta || {},
    alias: indexVeswRojeWIMeta?.alias || [],
    redirect: indexVeswRojeWIMeta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/my-plans/index.vue").then(m => m.default || m)
  },
  {
    name: _91uid_93N3VzvSwJ7wMeta?.name ?? "plan-sync-test-uid",
    path: _91uid_93N3VzvSwJ7wMeta?.path ?? "/plan-sync-test/:uid()",
    meta: _91uid_93N3VzvSwJ7wMeta || {},
    alias: _91uid_93N3VzvSwJ7wMeta?.alias || [],
    redirect: _91uid_93N3VzvSwJ7wMeta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/plan-sync-test/[uid].vue").then(m => m.default || m)
  },
  {
    name: _91uid_93bM3dGgBA6jMeta?.name ?? "plan-template-uid",
    path: _91uid_93bM3dGgBA6jMeta?.path ?? "/plan-template/:uid()",
    meta: _91uid_93bM3dGgBA6jMeta || {},
    alias: _91uid_93bM3dGgBA6jMeta?.alias || [],
    redirect: _91uid_93bM3dGgBA6jMeta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/plan-template/[uid].vue").then(m => m.default || m)
  },
  {
    name: sign_45up_45lifetimeA46WwbIs9iMeta?.name ?? "sign-up-lifetime",
    path: sign_45up_45lifetimeA46WwbIs9iMeta?.path ?? "/sign-up-lifetime",
    meta: sign_45up_45lifetimeA46WwbIs9iMeta || {},
    alias: sign_45up_45lifetimeA46WwbIs9iMeta?.alias || [],
    redirect: sign_45up_45lifetimeA46WwbIs9iMeta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/sign-up-lifetime.vue").then(m => m.default || m)
  },
  {
    name: sign_45upQkQ0oRhIPfMeta?.name ?? "sign-up",
    path: sign_45upQkQ0oRhIPfMeta?.path ?? "/sign-up",
    meta: sign_45upQkQ0oRhIPfMeta || {},
    alias: sign_45upQkQ0oRhIPfMeta?.alias || [],
    redirect: sign_45upQkQ0oRhIPfMeta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/sign-up.vue").then(m => m.default || m)
  },
  {
    name: _91uid_9397JExMoWECMeta?.name ?? "task-list-test-uid",
    path: _91uid_9397JExMoWECMeta?.path ?? "/task-list-test/:uid()",
    meta: _91uid_9397JExMoWECMeta || {},
    alias: _91uid_9397JExMoWECMeta?.alias || [],
    redirect: _91uid_9397JExMoWECMeta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/task-list-test/[uid].vue").then(m => m.default || m)
  },
  {
    name: indexhRW2RLPWb1Meta?.name ?? "template-library",
    path: indexhRW2RLPWb1Meta?.path ?? "/template-library",
    meta: indexhRW2RLPWb1Meta || {},
    alias: indexhRW2RLPWb1Meta?.alias || [],
    redirect: indexhRW2RLPWb1Meta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/template-library/index.vue").then(m => m.default || m)
  },
  {
    name: indexOQD3jYUc2SMeta?.name ?? "user-settings",
    path: indexOQD3jYUc2SMeta?.path ?? "/user-settings",
    meta: indexOQD3jYUc2SMeta || {},
    alias: indexOQD3jYUc2SMeta?.alias || [],
    redirect: indexOQD3jYUc2SMeta?.redirect || undefined,
    component: () => import("/home/runner/work/properplan/properplan/pages/user-settings/index.vue").then(m => m.default || m)
  }
]